import React from "react";
import { Button } from "antd";

const ReusableButton = ({
  text = "Button",
  onClick,
  loading = false,
  disabled = false,
  backgroundColor = "#212180",
  hoverBackgroundColor = "#212180",
  disabledBackgroundColor = "#A0A3C4",
  color = "#FFF",
  disabledColor = "#EEE",
  width = "118px",
  height = "40px",
  borderRadius = "4px",
  fontWeight = 600,
  customStyles = {},
  ...props
}) => {
  return (
    <Button
      style={{
        backgroundColor: disabled ? disabledBackgroundColor : backgroundColor,
        color: disabled ? disabledColor : color,
        border: "none",
        borderRadius,
        padding: "0 16px",
        height,
        fontWeight,
        width,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.7 : 1,
        transition: "all 0.3s",
        ...customStyles,
      }}
      loading={loading}
      onClick={!disabled ? onClick : undefined}
      {...props}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.target.style.backgroundColor = hoverBackgroundColor;
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled) {
          e.target.style.backgroundColor = backgroundColor;
        }
      }}
    >
      {text}
    </Button>
  );
};

export default ReusableButton;
